import { createFileRoute } from "@tanstack/react-router";
import { ScrollTextIcon } from "lucide-react";
import { warm } from "@/lib/workspace-queries";
import {
  AuditLogView,
  auditLogQuery,
  DEFAULT_AUDIT_LOG_PARAMS,
} from "@/ui/components/audit/audit-log-view";

export const Route = createFileRoute("/_workspace/audit")({
  // A head start on the first page; the view renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureQueryData(auditLogQuery("workspace", DEFAULT_AUDIT_LOG_PARAMS)));
  },
  component: AuditPage,
});

function AuditPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <ScrollTextIcon className="size-3.5" />
            Audit log
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Activity & audit log</h1>
          <p className="text-muted-foreground text-sm">
            A record of changes to employees, documents, and requests in your workspace — including
            who made each change and when.
          </p>
        </div>

        <AuditLogView scope="workspace" />
      </div>
    </main>
  );
}
